module.exports = __webpack_public_path__ + "img/76069.69216164.svg";